const MaintenanceMode = false;
const maintenanceAccessCode = '7355424008';
const maintenanceAccessCodeKey = 'maintenanceAccessCode';

export { MaintenanceMode, maintenanceAccessCode, maintenanceAccessCodeKey };
